import ServiceCategoryPage from "../components/ServiceCategoryPage";
import cctvTechnicianService from "../data/services/cctvTechnicianService";

function CCTVTechnician() {
  return <ServiceCategoryPage service={cctvTechnicianService} />;
}

export default CCTVTechnician;